// extracted by mini-css-extract-plugin
export default {"defaults":"Link_defaults__Mu5Xq","big":"Link_big__sSdnN","small":"Link_small__2Zm33","underlined":"Link_underlined__TWO8d"};